import { render, staticRenderFns } from "./UM_userList.vue?vue&type=template&id=72e9343c&scoped=true&"
import script from "./UM_userList.vue?vue&type=script&lang=js&"
export * from "./UM_userList.vue?vue&type=script&lang=js&"
import style0 from "./UM_userList.vue?vue&type=style&index=0&id=72e9343c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e9343c",
  null
  
)

export default component.exports